import { randomUUID } from 'node:crypto';
import type { BiLogger } from '@wix/wix-bi-logger-client';

export function addUserFields(logger: BiLogger, userId: string) {
  logger.updateDefaults(resolveUserFields(userId));
}

export function resolveUserFields(userId?: string): Record<string, string> {
  if (!userId) {
    // anonymous users need to have an identifier for the bi platform to accept the event
    return {
      _client_id: randomUUID(),
    };
  }

  return {
    _client_id: userId,
    _uuid: userId,
    logged_user_id: userId,
    logged_account_id: userId,
    target_account_id: userId,
  };
}
